import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("image4", component(opts));
  editor.BlockManager.add("image4", block(opts));
};